import {
  binCountSessionIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const activeSessionSchema = z.object({
  binCountSessionId: binCountSessionIdFormat.schema,
  totalBins: z.number(),
  completedBins: z.number(),
  sessionType: z.enum(["binCount", "skuCount"]),
  productId: productIdFormat.schema.optional(),
  productTitle: z.string().optional(),
  productSku: z.string().optional(),
});

export const getActiveBinCountSession = {
  name: "getActiveBinCountSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.array(activeSessionSchema),
};
